/**
 * Testimonials Block.
 * 
 */

/**
 * Desktop: Testimonial slides auto rotate via slick.
 * Mobile: ???
 */

const $ = jQuery;   // jQuery loaded via WordPress enqueue process

function initCarousel() {
	console.log("initCarousel()");
	let $mySlider = $('.testimonials__slides');

	console.log('$mySlider: '+$mySlider);

	$mySlider.slick({
		adaptiveHeight: true,
		arrows:false,
		autoplay: true,
		autoplaySpeed: 8000,
		dots: false,
		fade: true,
		infinite: true,
		slidesToScroll:1,
		slidesToShow: 1,
		speed: 800,
	});
}

exports.init = function () {
    // Run init methods...
    initCarousel();
};